import styled from 'styled-components';

export const ProfileSectionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 62px;
    border-radius: 12px;
    background-color: #212436;
    padding: 0 10px;
    -webkit-box-shadow: 0px 0px 10px -4px #000000;
    box-shadow: 0px 0px 10px -4px #000000;
`;

export const Divider = styled.div`
    width: 1px;
    height: 53px;
    margin: 5px 13px;
    border: solid 1px #282b3a;
`;
